import { YandexDiskResourceDto } from 'modules/match-video/domain/dtos';
import { DiskFolderVideo } from 'modules/match-video/domain/interfaces';

// Disk sometimes reports a video as `application/octet-stream`; the extension decides then.
const VIDEO_EXTENSION = /\.(mp4|m4v|mov)$/i;

export function isDiskVideo(item: YandexDiskResourceDto): boolean {
  return item.type === 'file' && (Boolean(item.mime_type?.startsWith('video/')) || VIDEO_EXTENSION.test(item.name));
}

export function toDiskFolderVideo(item: YandexDiskResourceDto): DiskFolderVideo {
  return {
    name: item.name,
    path: item.path,
    size: item.size ?? 0,
    mimeType: item.mime_type?.startsWith('video/') ? item.mime_type : 'video/mp4',
  };
}
